<sb-page-attachment-explorer *ngIf="show" [entity]="entity" [isEmbedded]="true"></sb-page-attachment-explorer>
